const _temp0 = require("./clips/Acid House.grufclip");
const _temp1 = require("./clips/Dub Reggae.grufclip");
const _temp2 = require("./clips/Funky Soul.grufclip");
const _temp3 = require("./clips/Hip Hop Classic 1.grufclip");
const _temp4 = require("./clips/Hip Hop Classic 2.grufclip");
const _temp5 = require("./clips/Reggae Roots.grufclip");
const _temp6 = require("./clips/Soul Pop.grufclip");
const _temp7 = require("./clips/Trap 1.grufclip");
const _temp8 = require("./clips/Trap 2.grufclip");
const _temp9 = require("./clips/Urban Reggaeton.grufclip");
module.exports = {
  "Acid House": _temp0,
  "Dub Reggae": _temp1,
  "Funky Soul": _temp2,
  "Hip Hop Classic 1": _temp3,
  "Hip Hop Classic 2": _temp4,
  "Reggae Roots": _temp5,
  "Soul Pop": _temp6,
  "Trap 1": _temp7,
  "Trap 2": _temp8,
  "Urban Reggaeton": _temp9
}